export interface ParsedAddress {
  streetNumber: string;
  streetName: string;
}

export function parseAddress(address: string): ParsedAddress | null {
  // STRICT: Both street number and street name must be successfully parsed
  // No fallback - if parsing fails, return null

  if (!address || address.trim() === '') {
    return null;
  }

  const trimmed = address.trim();

  // Regex patterns to match various address formats
  const patterns = [
    // Pattern 1: Standard "123 Main St" or "123A Main St"
    /^(\d+[A-Za-z]?)\s+(.+)$/,
    // Pattern 2: With direction "123 N Main St"
    /^(\d+[A-Za-z]?)\s+([NSEW]\.?\s+.+)$/i,
    // Pattern 3: PO Box (treat box number as street number, rest as street name)
    /^(PO Box|P\.O\. Box)\s+(\d+.*)$/i
  ];

  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match) {
      let streetNumber = match[1].trim();
      let streetName = match[2].trim();

      // For PO Box pattern, swap the parts
      if (/^(PO Box|P\.O\. Box)$/i.test(streetNumber)) {
        streetName = `${streetNumber} ${streetName}`;
        streetNumber = streetName.match(/\d+/)?.[0] || '';
      }

      // Remove apartment/unit suffixes from street name
      streetName = streetName.split(/\s+(Apt|Suite|Unit|#|Apartment)/i)[0].trim();

      // Validate both parts exist
      if (streetNumber && streetName) {
        return {
          streetNumber,
          streetName
        };
      }
    }
  }

  // NO FALLBACK - if we couldn't parse it properly, return null
  return null;
}
